/*
File: InstallBtn 添加/移除按钮
Author: SimonLu<luzuoqing@huya.com>
Date: 2020-03-17
*/

import classnames from 'classnames'
import React, { useState, useEffect, useCallback } from 'react'
import styles from './InstallBtn.scss?__local'
import { Icon, Modal, message } from 'antd'
import getTT from 'getTT';
import { useAction } from '@/hooks/useAction'
import { installExt, uninstallExt } from '@/api/api'
import * as R from 'ramda'


const hadOtherTestVersionCode = 7; // 已经安装了非正式版小程序的状态码

function InstallBtn({ hadInstall, extName, extUuid, extVersionId, isSlider = false }) {
  const [isInstalled, toggleInstalled] = useState(hadInstall)

  const [installState, performInstall, resetInstallState] = useAction(installExt)
  const [uninstallState, performUninstall, resetUninstallState] = useAction(uninstallExt)

  const install = ({ isCoverInstall = 0 }) => {
    resetUninstallState()
    performInstall({
      extUuid,
      extVersionId,
      isCoverInstall,
    })
    yaReportArr.push({
      eid: 'sys/click/appstore/extDetail/install',
      eid_desc: '小程序商店/详情页/安装',
      prop: JSON.stringify({
        extId: extUuid,
        isFree: true,
      }),
    })
  }

  const uninstall = () => {
    resetInstallState()
    performUninstall({
      extUuid,
      extVersionId,
    })

    yaReportArr.push({
      eid: 'sys/click/appstore/extDetail/unstall',
      eid_desc: '小程序商店/详情页/卸载',
      prop: JSON.stringify({
        extId: extUuid,
      }),
    })
  }

  useEffect(() => {
    const respCode = R.prop('respCode', installState)

    // console.log('installState.respCode', installState.respCode)
    if (respCode === hadOtherTestVersionCode) {
      Modal.confirm({
        title: `您已安装过该小程序的其他开发或测试版本，是否要直接安装当前版本？`,
        content: '',
        onOk: () => install({ isCoverInstall: 1 }),
        autoFocusButton: null,
        cancelText: '取消',
        okText: '确定',
      })
    } else if (respCode === 0) {
      toggleInstalled(R.T)
    }
  }, [installState.respCode])

  useEffect(() => {
    const respCode = R.prop('respCode', uninstallState)
    // console.log('uninstallState.respCode', respCode)

    if (respCode === 0) {
      toggleInstalled(R.F)
    }
  }, [uninstallState.respCode])

  const handleClick = useCallback(() => {
    if (!isInstalled) {
      return getTT(TT => TT.sudo(install))
    }

    if (isInstalled) {
      Modal.confirm({
        title: `确定要移除“${extName}”么？`,
        content: '',
        okType: 'danger',
        onOk: uninstall,
        autoFocusButton: null,
        cancelText: '取消',
        okText: '确定',
      })
    }
  }, [isInstalled])

  if (R.any(R.prop('isLoading'), [installState, uninstallState])) {
    return (
      <span className={classnames(styles.button, styles.loading)}>
        <Icon type="loading" />
      </span>
    )
  }

  if (isInstalled) {
    return (
      <span className={classnames(styles.button, styles.remove, isSlider ? styles.sliderButton : '')} onClick={handleClick}>
        <span>已添加</span>
      </span>
    )
  }

  return (
    <span className={classnames(styles.button, styles.add, isSlider ? styles.sliderButton : '')} onClick={handleClick}>
      <Icon type="plus" />
      <span>添加</span>
    </span>
  )
}

export default InstallBtn
